import { type CSSProperties } from 'react';

const CHIP_ASSET = `${process.env.PUBLIC_URL || ''}/assets/casino-chip.png`;

/** Subtle hue shifts so stacked chips stay readable without breaking the brand chip art */
const VARIANT_FILTERS = [
  'none',
  'hue-rotate(18deg) saturate(1.05)',
  'hue-rotate(-14deg) saturate(1.08)',
  'hue-rotate(32deg) saturate(0.95)',
  'hue-rotate(-28deg) saturate(1.02)',
  'hue-rotate(8deg) brightness(1.04)',
];

interface PremiumCasinoChipProps {
  size?: number;
  className?: string;
  style?: CSSProperties;
  variant?: number;
  chipFilter?: string;
}

/** Premium ₹100 casino chip — PNG design asset with transparent background */
export default function PremiumCasinoChip({
  size = 72,
  className = '',
  style,
  variant = 0,
  chipFilter,
}: PremiumCasinoChipProps) {
  const variantFilter = VARIANT_FILTERS[Math.abs(variant) % VARIANT_FILTERS.length];
  const combinedFilter = [chipFilter ?? 'drop-shadow(0 3px 8px rgba(0, 0, 0, 0.55))', variantFilter]
    .filter(Boolean)
    .join(' ');

  return (
    <img
      src={CHIP_ASSET}
      alt=""
      aria-hidden
      draggable={false}
      width={size}
      height={size}
      className={`premium-casino-chip shrink-0 select-none ${className}`}
      style={{
        width: size,
        height: size,
        objectFit: 'contain',
        filter: combinedFilter,
        ...style,
      }}
    />
  );
}
